
'use strict'

const trackEvent = (category, action, label) => {
  // console.log("ga('send', 'event')", category, action, label)
  window.ga('send', 'event', category, action, label)
}

const trackPageview = (pageName) => {
  // ga('set', 'page', pageName)
  // console.log("ga('send', 'pageview')", pageName)
  window.ga('send', 'pageview', pageName)
}

export {
  trackEvent,
  trackPageview
}




/** WEBPACK FOOTER **
 ** ./src/scripts/client/utilities/tracker.js
 **/